import React from "react";
import { ShareBtnProps } from "./ShareButton.types";

import { useTranslation, I18nextProvider } from "react-i18next";
import instance from "../../utils/i18n";

import "@esri/calcite-components/dist/components/calcite-button";
import "@esri/calcite-components/dist/components/calcite-icon";
import { CalciteButton, CalciteIcon } from "@esri/calcite-components-react";
import { isIOS } from "react-device-detect";
import styled from "styled-components";

const StyledSpan = styled.span`
  padding: 1px 0;
  box-sizing: border-box;
`;

const StyledLinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a19bc;
  font: inherit;
  font-size: 1.05rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;

  calcite-icon {
    color: #202020;
  }
`;

const onShareClick = (shareUrl: string) => {
  if (navigator.share) {
    navigator
      .share({
        title: document.title,
        url: shareUrl,
      })
      .catch(console.error);
  } else {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => alert("The address is copied to the clipboard!"))
      .catch(console.error);
  }
};

const ShareButton = ({ shareUrl, shareText, variant = "button" }: ShareBtnProps) => {
  const { i18n } = useTranslation("components", { i18n: instance });

  if (variant === "link") {
    return (
      <I18nextProvider i18n={i18n}>
        <div className="share-btn">
          <StyledLinkButton type="button" onClick={() => onShareClick(shareUrl)}>
            <CalciteIcon icon={isIOS ? "share-ios" : "share"} scale="m" />
            <StyledSpan>{shareText}</StyledSpan>
          </StyledLinkButton>
        </div>
      </I18nextProvider>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <div className="share-btn">
        <CalciteButton
          class="lib-neutral-button"
          id="share-btn"
          onClick={() => onShareClick(shareUrl)}
          appearance="outline"
          iconStart={isIOS ? "share-ios" : "share"}
          kind="neutral"
          scale="m"
          style={
            {
              backgroundColor: "#FFFFFF",
              color: "#1A19BC"
            } as React.CSSProperties
          }
        >
          <StyledSpan>{shareText}</StyledSpan>
        </CalciteButton>
      </div>
    </I18nextProvider>
  );
};

export default ShareButton;